import tw from 'tailwind-styled-components'

export const TwTaskNameWrapper = tw.div`
  w-full
  h-full
  px-8
  pl-12
  flex
  flex-col
  justify-between
  gap-8
`

export const TwTaskName = tw.div<{$isRenaming: boolean}>`
  flex
  items-center
  gap-8
  ${p => (p.$isRenaming ? 'h-full' : 'h-32')}
`

export const TwTaskDoneIconWrapper = tw.div`
  h-full
  flex
  items-center
`

export const TwSelected = tw.div`
  absolute
  bg-action-default
  -top-1
  -bottom-1
  -left-2
  w-4
  left-0
  rounded-l-12
`

export const TwTaskNameTitleWrapper = tw.div`
  flex
  flex-col
  min-w-0
  w-full
`

export const TwProgressbarWrapper = tw.div`
  flex
  w-full
  gap-4
  max-w-[304px]
  hide-on-drag
`

export const TwLocation = tw.div`
  h-16
  w-full
`

export const TwTaskNameEditing = tw.textarea`
  box-content
  m-0
  p-0
  !border-none
  !resize-none
  !bg-transparent
  !w-initial
  !shadow-border-b-1
  min-h-0
  text-14
  leading-[16px]
  break-words
  whitespace-pre-wrap
  overflow-hidden
  
  text-primary
  font-semibold
`

export const TwTasks = tw.div`
  text-12
  text-placeholder
  leading-[16px]
  w-fit
  max-w-full
  truncate
`


export const TwFavoritesColumn = tw.div`
  h-32
  w-full
  flex
  justify-end
  items-center
  gap-4
`
